import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import {
  CustomerFeeWalletFormData,
  customerFeeWalletSchema,
} from '../schemas/customerFeeWalletSchema'

export const useCustomerFeeWalletForm = () => {
  const { t } = useTranslation()
  const formSchema = customerFeeWalletSchema(t)

  const form = useForm<CustomerFeeWalletFormData>({
    resolver: yupResolver(formSchema),
    defaultValues: {
      walletReference: '',
    },
  })

  const {
    control,
    formState,
    clearErrors,
    resetField,
    setValue,
    register,
    trigger,
    setError,
    handleSubmit,
  } = form

  const formValues = useWatch({ control }) as CustomerFeeWalletFormData

  return {
    formValues,
    formState,
    errors: formState.errors,
    clearErrors,
    resetField,
    setValue,
    register,
    setError,
    trigger,
    handleSubmit,
    form,
  }
}
